import { Injectable } from '@angular/core';
import * as moment from 'moment-timezone';

@Injectable({
  providedIn: 'root'
})
export class AppTimeService {
  constructor() { }

  // Convert UTC date to local date
  utcToLocalDate(utcDate: string, timezone: string, formate: string = 'YYYY-MM-DD'): string {
    return moment.utc(utcDate).tz(timezone).format(formate);
  }

  // Convert UTC date to local time
  utcToLocalTime(utcDate: string, timezone: string): string {
    return moment.utc(utcDate).tz(timezone).format('hh:mm A');
  }

  // Convert local date to UTC date
  localToUtcDate(localDate: string, timezone: string, formate: string = 'YYYY-MM-DD'): string {
    return moment.tz(localDate, formate, timezone).utc().format();
  }

  // Convert local time to UTC date
  localToUtcTime(localTime: string, timezone: string): string {
    return moment.tz(localTime, 'hh:mm A', timezone).utc().format();
  }

  // Get date only
  getDateOnly(date: string, timezone: string, formate: string = 'YYYY-MM-DD'): string {
    return moment.tz(date, timezone).format(formate);
  }

  // Get time only
  getTimeOnly(date: string, timezone: string): string {
    return moment.tz(date, timezone).format('hh:mm A');
  }

  // Get date and time
  getDateAndTime(date: string, timezone: string, formate: string = 'YYYY-MM-DD hh:mm A'): string {
    return moment.tz(date, timezone).format(formate);
  }

  // Get short date
  getShortDate(date: string, timezone: string, formate: string = 'MMM DD, YYYY'): string {
    return moment.tz(date, timezone).format(formate);
  }

  // Convert UTC date to local date and time
  utcToLocalDateAndTime(utcDate: string, timezone: string, formate: string = 'YYYY-MM-DD hh:mm A'): string {
    return moment.utc(utcDate).tz(timezone).format(formate);
  }

  // Convert local date and time to UTC date
  localToUtcDateAndTime(localDateTime: string, timezone: string, formate: string = 'YYYY-MM-DD hh:mm A'): string {
    return moment.tz(localDateTime, formate, timezone).utc().format();
  }

  // Get the current user's timezone
  getCurrentUserTimezone(): string {
    return moment.tz.guess(true);
  }

}